import { ApiResult, CrudService, Meta } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {ProdutoFabricanteEntity, SolicitacaoProcessamentoEntity} from '@catalogo/models';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";
import { EnumTipoAutenticacaoEnvioPortalUnico } from "@catalogo/features/operacional/enums/enum-entities";

@Injectable({providedIn: 'root'})
export class ProdutoFabricanteDataService extends CrudService<ProdutoFabricanteEntity> {
    protected url: string;
    urlOriginal: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.urlOriginal = `${urlBase}/v1/Produto/<id>/Fabricante`;
    }

    public withParentId(parentId: string) {
        this.url = this.urlOriginal.replace("<id>", parentId);
        return this;
    }

    public pendenteEnvioPortalUnico() {
        this.url = `${this.urlOriginal.replace('/<id>', '')}/PendentesPortalUnico`;
        return this;
    }

    public exportar = (meta: Meta) =>
        this.httpClient.post<ApiResult<string>>(`${this.urlOriginal.replace('/<id>', '')}/Exportar`, meta);

    public obterUltimaSolicitacaoImportacaoPortalUnico = () =>
        this.httpClient.get<ApiResult<SolicitacaoProcessamentoEntity>>(`${this.urlBase}/v1/Produto/Fabricante/CapturaPortalUnico/Atual`);

    public solicitarCapturaPortalUnico = (payload: FormData) =>
        this.httpClient.post<any>(`${this.urlBase}/v1/Produto/Fabricante/SolicitarCapturaPortalUnico`, payload);

    public solicitarEnvioPortalUnico(fabricantes: string[], senhaCertificado: string, tipoAutenticacao: EnumTipoAutenticacaoEnvioPortalUnico, desvincular: boolean) {
        return this.httpClient.post<ApiResult<any>>(`${this.urlBase}/v1/Produto/Fabricante/SolicitarEnvioPortalUnico`, {
            fabricantes,
            senhaCertificado,
            tipoAutenticacao: <EnumTipoAutenticacaoEnvioPortalUnico>tipoAutenticacao,
            desvincular
        });
    }

    public obter = (id: string) =>
        this.httpClient.get<ApiResult<ProdutoFabricanteEntity>>(`${this.urlBase}/v1/Produto/Fabricante/${id}`, {})
}
